import './rich-text-editor.menu-item.scss';
import 'remixicon/fonts/remixicon.css';

interface IRichTextBoxMenuItem {
  icon?: string;
  title?: string;
  action?: () => boolean;
  isActive?: (name?: string) => boolean;
  type?: string;
  disabled?: boolean;
}

export const RichTextBoxMenuItem = ({
  icon,
  title,
  action,
  isActive,
  disabled,
}: IRichTextBoxMenuItem) => (
  <button
    className={`menu-item${isActive && isActive() ? ' is-active' : ''}${
      disabled ? ' disabled' : ''
    }`}
    onClick={() => {
      if (disabled) {
        return;
      }
      if (action) {
        action();
      }
    }}
    title={title}
    type="button"
    disabled={disabled}
  >
    <i className={`ri-${icon}`}></i>
  </button>
);
